export default function MemedLogo({ className }: { className?: string }) {
  return (
    <svg
      width="160"
      height="56"
      viewBox="0 0 160 56"
      fill="none"
      className={`${className} md:w-fit w-24`}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_123_244)">
        <mask
          id="path-1-outside-1_123_244"
          maskUnits="userSpaceOnUse"
          x="-0.131348"
          y="-0.131409"
          width="160"
          height="53"
          fill="black"
        >
          <rect
            fill="white"
            x="-0.131348"
            y="-0.131409"
            width="160"
            height="53"
          ></rect>
          <path d="M0.868652 51.1045V20.8344H5.60004V16.2105H12.4283V20.8344H17.2134V30.0283H19.848V20.8344H24.6331V16.2105H31.5151V20.8344H36.1927V51.1045H29.4183V23.5764H26.73V32.7166H21.9448V46.5344H15.1166V32.7166H10.3314V23.5764H7.6969V51.1045H0.868652Z"></path>
          <path d="M46.6438 46.2474V42.2949H42.5518V20.0678H46.6438V16.0688H60.7798V20.0678H64.9183V26.3918H58.9663V22.4393H48.4573V28.0193H56.6878V34.2968H48.4573V39.9234H58.9663V35.9243H64.9183V42.2949H60.7798V46.2474H46.6438Z"></path>
          <path d="M70.5148 43.5937V19.8684H74.2232V16.2443H79.5751V19.8684H83.3256V27.0745H85.3905V19.8684H89.141V16.2443H94.535V19.8684H98.2013V43.5937H92.8915V22.0176H90.7845V29.1815H87.034V40.0117H81.6821V29.1815H77.9316V22.0176H75.8667V43.5937H70.5148Z"></path>
          <path d="M107.879 46.2474V42.2949H103.787V20.0678H107.879V16.0688H122.015V20.0678H126.153V26.3918H120.201V22.4393H109.692V28.0193H117.923V34.2968H109.692V39.9234H120.201V35.9243H126.153V42.2949H122.015V46.2474H107.879Z"></path>
          <path d="M125.399 11.1916V7.1926H123.4V2.91459H125.399V0.868591H129.259V4.8211H131.351V11.1916H125.399Z"></path>
          <path d="M132.459 51.1045V16.2105H148.804V20.8344H153.535V25.4045H158.32V41.9106H153.535V46.5344H148.804V51.1045H132.459ZM139.287 43.7924H146.707V39.1685H151.438V28.1465H146.707V23.5764H139.287V43.7924Z"></path>
        </mask>
        <path
          d="M0.868652 51.1045V20.8344H5.60004V16.2105H12.4283V20.8344H17.2134V30.0283H19.848V20.8344H24.6331V16.2105H31.5151V20.8344H36.1927V51.1045H29.4183V23.5764H26.73V32.7166H21.9448V46.5344H15.1166V32.7166H10.3314V23.5764H7.6969V51.1045H0.868652Z"
          fill="#96FF43"
        ></path>
        <path
          d="M46.6438 46.2474V42.2949H42.5518V20.0678H46.6438V16.0688H60.7798V20.0678H64.9183V26.3918H58.9663V22.4393H48.4573V28.0193H56.6878V34.2968H48.4573V39.9234H58.9663V35.9243H64.9183V42.2949H60.7798V46.2474H46.6438Z"
          fill="#96FF43"
        ></path>
        <path
          d="M70.5148 43.5937V19.8684H74.2232V16.2443H79.5751V19.8684H83.3256V27.0745H85.3905V19.8684H89.141V16.2443H94.535V19.8684H98.2013V43.5937H92.8915V22.0176H90.7845V29.1815H87.034V40.0117H81.6821V29.1815H77.9316V22.0176H75.8667V43.5937H70.5148Z"
          fill="#96FF43"
        ></path>
        <path
          d="M107.879 46.2474V42.2949H103.787V20.0678H107.879V16.0688H122.015V20.0678H126.153V26.3918H120.201V22.4393H109.692V28.0193H117.923V34.2968H109.692V39.9234H120.201V35.9243H126.153V42.2949H122.015V46.2474H107.879Z"
          fill="#96FF43"
        ></path>
        <path
          d="M125.399 11.1916V7.1926H123.4V2.91459H125.399V0.868591H129.259V4.8211H131.351V11.1916H125.399Z"
          fill="#96FF43"
        ></path>
        <path
          d="M132.459 51.1045V16.2105H148.804V20.8344H153.535V25.4045H158.32V41.9106H153.535V46.5344H148.804V51.1045H132.459ZM139.287 43.7924H146.707V39.1685H151.438V28.1465H146.707V23.5764H139.287V43.7924Z"
          fill="#96FF43"
        ></path>
        <path
          d="M0.868652 51.1045V20.8344H5.60004V16.2105H12.4283V20.8344H17.2134V30.0283H19.848V20.8344H24.6331V16.2105H31.5151V20.8344H36.1927V51.1045H29.4183V23.5764H26.73V32.7166H21.9448V46.5344H15.1166V32.7166H10.3314V23.5764H7.6969V51.1045H0.868652Z"
          stroke="black"
          stroke-width="1.73717"
          mask="url(#path-1-outside-1_123_244)"
        ></path>
        <path
          d="M46.6438 46.2474V42.2949H42.5518V20.0678H46.6438V16.0688H60.7798V20.0678H64.9183V26.3918H58.9663V22.4393H48.4573V28.0193H56.6878V34.2968H48.4573V39.9234H58.9663V35.9243H64.9183V42.2949H60.7798V46.2474H46.6438Z"
          stroke="black"
          stroke-width="1.73717"
          mask="url(#path-1-outside-1_123_244)"
        ></path>
        <path
          d="M70.5148 43.5937V19.8684H74.2232V16.2443H79.5751V19.8684H83.3256V27.0745H85.3905V19.8684H89.141V16.2443H94.535V19.8684H98.2013V43.5937H92.8915V22.0176H90.7845V29.1815H87.034V40.0117H81.6821V29.1815H77.9316V22.0176H75.8667V43.5937H70.5148Z"
          stroke="black"
          stroke-width="1.73717"
          mask="url(#path-1-outside-1_123_244)"
        ></path>
        <path
          d="M107.879 46.2474V42.2949H103.787V20.0678H107.879V16.0688H122.015V20.0678H126.153V26.3918H120.201V22.4393H109.692V28.0193H117.923V34.2968H109.692V39.9234H120.201V35.9243H126.153V42.2949H122.015V46.2474H107.879Z"
          stroke="black"
          stroke-width="1.73717"
          mask="url(#path-1-outside-1_123_244)"
        ></path>
        <path
          d="M125.399 11.1916V7.1926H123.4V2.91459H125.399V0.868591H129.259V4.8211H131.351V11.1916H125.399Z"
          stroke="black"
          stroke-width="1.73717"
          mask="url(#path-1-outside-1_123_244)"
        ></path>
        <path
          d="M132.459 51.1045V16.2105H148.804V20.8344H153.535V25.4045H158.32V41.9106H153.535V46.5344H148.804V51.1045H132.459ZM139.287 43.7924H146.707V39.1685H151.438V28.1465H146.707V23.5764H139.287V43.7924Z"
          stroke="black"
          stroke-width="1.73717"
          mask="url(#path-1-outside-1_123_244)"
        ></path>
      </g>
      <defs>
        <filter
          id="filter0_d_123_244"
          x="0"
          y="0"
          width="159.189"
          height="55.8817"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          ></feColorMatrix>
          <feOffset dy="3.90863"></feOffset>
          <feComposite in2="hardAlpha" operator="out"></feComposite>
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
          ></feColorMatrix>
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_123_244"
          ></feBlend>
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_123_244"
            result="shape"
          ></feBlend>
        </filter>
      </defs>
    </svg>
  );
}
